import { GET_ALL_COLUMNS_SUCCESS, SELECT_ACCOUNT } from "../channel/type";
import { channelType } from "./transformer";

const INITIAL_STATE = {
    isConnecting: false,
    accountData: {},
    dimensions: [],
    metrics: [],
    customDimensions: [],
    customMetrics: [],
    currency: null,
    metricsUpdated: false,
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${channelType}.SHOW_CONNECT_ACCOUNT`:
            return { ...state, isConnecting: true };
        case `${channelType}.HIDE_CONNECT_ACCOUNT`:
            return { ...state, isConnecting: false };
        case `${channelType}.GET_ACCOUNT_SUMMARY_SUCCESS`:
            const username = action.payload.accessTokenName;
            const email = action.payload.accessTokenName;
            const accountList = [];
            action.payload.listOfAppIds.forEach((account) => {
                accountList.push({
                    title: account.name,
                    subtitle: account.id,
                    accountId: account.id
                });
            })
            return { ...state, accountData: { users: [{ username: username, email: email }], accountList: accountList } };
        case `${channelType}.DISCONNECT_ACCOUNT_SUCCESS`:
        case `${channelType}.GET_ACCOUNT_SUMMARY_FAILURE`:
            return { ...INITIAL_STATE };
        case `${channelType}.GET_FIELDS_SUCCESS`:
            const dimensionArr = action.payload.columns.filter(c => c.type === "DIMENSION");
            const metricArr = action.payload.columns.filter(c => c.type === "METRIC");
            return { ...state, dimensions: dimensionArr, metrics: metricArr, metricsUpdated: true };
        case `${channelType}.GET_CUSTOM_FIELDS_SUCCESS`:
            const customDimensions = action.payload.columns.filter(c => c.type === "DIMENSION");
            const customMetrics = action.payload.columns.filter(c => c.type === "METRIC");
            return { ...state, customDimensions: customDimensions, customMetrics: customMetrics, metricsUpdated: state.metrics.length && state.dimensions.length };
        case GET_ALL_COLUMNS_SUCCESS:
            const cc = action.payload.filter(column => column.source === channelType).map(column => ({
                id: column.id,
                name: column.name,
                dataType: column.format ?? "FLOAT",
                group: "Customized",
            }));
            return { ...state, metrics: state.metrics.filter(m => m.group !== "Customized").concat(cc) };
        case `${channelType}.GET_CURRENCY_SUCCESS`:
            return { ...state, currency: action.payload }
        case SELECT_ACCOUNT:
            if (action.payload.channel === channelType) {
                return { ...state, customDimensions: [], customMetrics: [], metricsUpdated: false };
            }
            return state;
        default:
            return state;
    }
};

export default reducer;
